import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {UrlModel} from '../../../../common/services/url/url.model';
import {FormModel} from '../../../../common/components/form/models';
import {
  ModaleRenduFormulaireComponent
} from '../../../formulaires-liste/rendu-formulaire/modale-rendu-formulaire-container/modale-rendu-formulaire.component';
import {HelperService} from '../../../../common/services/helper.service';

@Component({
  selector: 'app-url-edit-modale',
  templateUrl: './modal-url-edit.component.html',
  styleUrls: ['./modal-url-edit.component.scss']
})
export class ModalUrlEditComponent implements OnInit {
  url: UrlModel;
  constructor(@Inject(MAT_DIALOG_DATA) public data: UrlModel,
              public dialogRef: MatDialogRef<ModalUrlEditComponent>) {
    this.url = data;
  }

  ngOnInit(): void {
  }
  onChangedForm(forms: [currentForm: FormModel, newForm: FormModel]) {
    this.dialogRef.close(forms);
  }
}
